import axiosClient from '@clients/axiosClient';

export type GetCardControlCustomerPayload = {
    accountId: number;
    customerId: string;
    flexId: string;
};

export type GetCardControlAccountPayload = {
    accountId: string;
    flexId: string;
};

export type GetCardControlsResponse = {
    id: string;
    type: string;
    name: string;
    beneficiary_id: string;
    override_controls: string[];
    description: string;
    processing_codes: string[];
    country_codes: string[];
    currency_code: string;
    time_zone: string;
    max_limit: number;
    available_limit: number;
    conditions: GetCardControlsConditionsResponse[];
    limit_duration: string;
    reset_period: {
        month_day: number;
        week_day: string;
        time: string;
    };
    reset_datetime: string;
    active: boolean;
    customized: boolean;
    rule_reference_id: string;
    account_id: number;
    customer_id: number;
    card_ids: number[];
    deny_code: string;
};

export type GetCardControlsConditionsResponse = {
    id?: string;
    attribute: string;
    operator: string;
    value: string;
};

const flexControlCustomerClient = () => {
    const client = axiosClient();

    return {
        async getFlexCardControlCustomer({
            accountId,
            customerId,
            flexId,
        }: GetCardControlCustomerPayload) {
            const { data } = await client.get<GetCardControlsResponse>(
                `/rules/v1/customers/${customerId}/flex-controls/${flexId}`,
                { headers: { 'x-account-id': accountId } },
            );
            return data;
        },
    };
};

export default flexControlCustomerClient;
